/**
 * Hulk Forms Customizer - Wedding Consultation Form
 * Detecta automáticamente formularios de Hulk Forms y aplica estilos personalizados
 */

class HulkFormsCustomizer {
  constructor() {
    this.formId = 'wizard-validation-form';
    this.formClass = 'hulk_form_EVTZcBdYT8Gk7-aOFZaTuw';
    this.init();
  }

  init() {
    // Esperar a que el DOM esté listo
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupCustomizer());
    } else {
      this.setupCustomizer();
    }
  }

  setupCustomizer() {
    // Buscar el formulario específico
    const formElement = document.getElementById(this.formId) || 
                       document.querySelector(`.${this.formClass}`) ||
                       document.querySelector('[class*="hulk_form_"]');

    if (formElement) {
      console.log('Hulk Forms detectado:', formElement);
      this.applyCustomStyles(formElement);
      this.setupObserver(formElement);
    } else {
      // Si no se encuentra inmediatamente, intentar después de un breve delay
      setTimeout(() => this.setupCustomizer(), 500);
    }
  }

  applyCustomStyles(formElement) {
    // Aplicar clase personalizada al formulario
    formElement.classList.add('hulk-forms-customized');

    // Forzar alineación izquierda en contenedores principales
    this.forceLeftAlignment(formElement);

    // Mejorar grid layout
    this.enhanceGridLayout(formElement);

    // Mejorar campos de teléfono
    this.enhancePhoneFields(formElement);

    // Mejorar checkboxes
    this.enhanceCheckboxes(formElement);

    // Mejorar accesibilidad
    this.enhanceAccessibility(formElement);

    console.log('Estilos personalizados aplicados al formulario Hulk Forms');
  }

  forceLeftAlignment(formElement) {
    // Contenedores principales
    const containers = [
      formElement,
      formElement.querySelector('.formContainer'),
      formElement.querySelector('.form_generater_form_div')
    ].filter(Boolean);

    containers.forEach(container => {
      container.style.setProperty('width', '100%', 'important');
      container.style.setProperty('max-width', '100%', 'important');
      container.style.setProperty('text-align', 'left', 'important');
      container.style.setProperty('margin', '0', 'important');
    });

    // Todos los elementos dentro del formulario
    const allElements = formElement.querySelectorAll('*');
    allElements.forEach(element => {
      if (!element.matches('.btn, .form_captcha_div, .alert_message')) {
        element.style.setProperty('text-align', 'left', 'important');
      }
    });
  }

  enhanceGridLayout(formElement) {
    // Mejorar el layout de grid para campos
    const formContainer = formElement.querySelector('.form_container .row');
    if (formContainer) {
      formContainer.style.setProperty('display', 'flex', 'important');
      formContainer.style.setProperty('flex-wrap', 'wrap', 'important');
      formContainer.style.setProperty('gap', '1rem', 'important');
      formContainer.style.setProperty('width', '100%', 'important');
      formContainer.style.setProperty('margin', '0', 'important');
    }

    // Mejorar campos individuales
    const fields = formElement.querySelectorAll('[class*="formElement_"]');
    fields.forEach(field => {
      field.style.setProperty('margin-bottom', '1.5rem', 'important');
      field.style.setProperty('text-align', 'left', 'important');
      field.style.setProperty('width', '100%', 'important');
    });
  }

  enhancePhoneFields(formElement) {
    // Mejorar campos de teléfono
    const phoneContainers = formElement.querySelectorAll('.phone_div');
    phoneContainers.forEach(container => {
      container.style.setProperty('display', 'flex', 'important');
      container.style.setProperty('gap', '0.5rem', 'important');
      
      const select = container.querySelector('select');
      const input = container.querySelector('input[type="number"]');
      
      if (select) {
        select.style.setProperty('flex', '1', 'important');
      }
      if (input) {
        input.style.setProperty('flex', '1', 'important');
      }
    });
  }

  enhanceCheckboxes(formElement) {
    // Mejorar checkboxes múltiples
    const checkboxContainers = formElement.querySelectorAll('.checkbox-multiple, .checkbox-list');
    checkboxContainers.forEach(container => {
      container.style.setProperty('display', 'flex', 'important');
      container.style.setProperty('flex-wrap', 'wrap', 'important');
      container.style.setProperty('gap', '1rem', 'important');
      container.style.setProperty('margin-top', '0.5rem', 'important');
    });

    const checkboxItems = formElement.querySelectorAll('.checkbox-inline');
    checkboxItems.forEach(item => {
      item.style.setProperty('display', 'flex', 'important');
      item.style.setProperty('align-items', 'center', 'important');
      item.style.setProperty('gap', '0.5rem', 'important');
      item.style.setProperty('margin', '0', 'important');
    });
  }

  enhanceAccessibility(formElement) {
    // Mejorar accesibilidad
    const inputs = formElement.querySelectorAll('input, select, textarea');
    inputs.forEach(input => {
      if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
        const label = input.closest('.form-group')?.querySelector('label') ||
                     input.parentElement?.querySelector('label');
        if (label) {
          const labelText = label.textContent?.trim();
          if (labelText) {
            input.setAttribute('aria-label', labelText);
          }
        }
      }
    });

    // Mejorar botones
    const buttons = formElement.querySelectorAll('button:not([aria-label])');
    buttons.forEach(button => {
      if (button.textContent?.trim()) {
        button.setAttribute('aria-label', button.textContent.trim());
      }
    });
  }

  setupObserver(formElement) {
    // Observer para cambios dinámicos
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Reaplica estilos a nuevos elementos
              if (node.matches('[class*="formElement_"]') || 
                  node.querySelector('[class*="formElement_"]')) {
                this.applyCustomStyles(formElement);
              }
            }
          });
        }
      });
    });

    observer.observe(formElement, {
      childList: true,
      subtree: true
    });

    // Guardar referencia para cleanup
    formElement._hulkObserver = observer;
  }

  // Método para cleanup manual
  destroy(formElement) {
    if (formElement && formElement._hulkObserver) {
      formElement._hulkObserver.disconnect();
      delete formElement._hulkObserver;
    }
  }
}

// Función de utilidad para aplicar estilos específicos
function applyHulkFormsStyles() {
  // Buscar formularios de Hulk
  const hulkForms = document.querySelectorAll('[id*="wizard-validation-form"], [class*="hulk_form_"]');
  
  hulkForms.forEach(form => {
    // Aplicar estilos directamente vía JavaScript para mayor control
    form.style.setProperty('width', '100%', 'important');
    form.style.setProperty('max-width', '100%', 'important');
    form.style.setProperty('text-align', 'left', 'important');
    form.style.setProperty('margin', '0', 'important');

    // Aplicar a contenedores internos
    const containers = form.querySelectorAll('.formContainer, .form_generater_form_div');
    containers.forEach(container => {
      container.style.setProperty('width', '100%', 'important');
      container.style.setProperty('max-width', '100%', 'important');
      container.style.setProperty('text-align', 'left', 'important');
      container.style.setProperty('margin', '0', 'important');
    });
  });
}

// Inicializar el customizer
const hulkCustomizer = new HulkFormsCustomizer();

// También exponer función de utilidad globalmente
window.applyHulkFormsStyles = applyHulkFormsStyles;

// Aplicar estilos cada vez que se carga la página
window.addEventListener('load', applyHulkFormsStyles);

// También aplicar cuando el DOM cambie (para formularios cargados dinámicamente)
document.addEventListener('DOMContentLoaded', applyHulkFormsStyles);

console.log('Hulk Forms Customizer cargado correctamente');
